import React, { useContext, useRef, useState } from "react";
import VideoContext from "../../context/video/videoContext";
import AuthContext from "../../context/auth/authContext";

const ReplyBox = (props) => {
  const videoContext = useContext(VideoContext);
  const authContext = useContext(AuthContext);
  const { addError, currentUser } = authContext;

  const text = useRef("");
  const [open, setOpen] = useState(false);
  const toggleOpen = () => {
    setOpen(!open);
  };

  const addNewReply = (e) => {
    e.preventDefault();
    if (text.current.value === "") {
      addError("No comment Given");
    } else if (!currentUser) {
      addError("Log in to comment");
    } else {
      let Newcomment = {
        UserName: currentUser.displayName,
        UserProfile: currentUser.photoURL,
        body: text.current.value,
        commentid: props.commentid,
        userid: currentUser.uid,
      };
      videoContext.addReply(Newcomment);
    }
    text.current.value = "";
    toggleOpen();
  };
  return (
    <div className='pl-4'>
      {!open && (
        <button className='btn btn-dark float-right' onClick={toggleOpen}>
          <i className='fas fa-reply'></i>
        </button>
      )}
      {open && (
        <div className='card overflow-hidden'>
          <div class='input-group mb-3 card-body'>
            <input
              ref={text}
              className='form-control simplefont'
              size='160'
              type='text'
            />{" "}
            <div class='input-group-append'>
              <button
                type='submit'
                onClick={addNewReply}
                className='btn btn-dark'
              >
                <i className='fas fa-check'></i>
              </button>{" "}
              <button class='btn btn-danger' type='button' onClick={toggleOpen}>
                <i className='fas fa-times'></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReplyBox;
